import { configureStore } from "@reduxjs/toolkit";
import featureToggleSlice from "../features/featureToggles/featureToggleSlice";
import currentUserSlice from "../features/auth/currentUserSlice";
import templateSlice from "features/templates/templateSlice";
import favoriteTemplateSlice from "features/templates/favoriteTemplateSlice";
import qualityFormSlice from "features/qualityForm/qualityFormSlice";
import scorableSlice from "features/scorable/scorableSlice";
import topicsSlice from "features/topics/topicsSlice";
import usersSlice from "features/users/usersSlice";
import copyFormSlice from "features/qualityForm/formEditor/copyFormSlice";
import divisionsSlice from "features/divisions/divisionsSlice";

const store = configureStore({
    reducer: {
        featureToggle: featureToggleSlice,
        qualityForm: qualityFormSlice,
        currentUser: currentUserSlice,
        template: templateSlice,
        favoriteTemplates: favoriteTemplateSlice,
        scorable: scorableSlice,
        users: usersSlice,
        topics: topicsSlice,
        copyForm: copyFormSlice,
        divisions: divisionsSlice,
    },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;
